import { integrationsDirectCdiSources } from "@dashboardApi/apis/integrationsDirectCdiSources/constants";

import type { AllRouteEndpoints } from "../routeTypes";
export const integrationsDirectCdiSourcesSourceIdCacheKeys: AllRouteEndpoints[] = [integrationsDirectCdiSources];

export const patchIntegrationsDirectCdiSourcesSourceIdCacheKeys: AllRouteEndpoints[] = [];
